/*
 * @description: 
 * @Author: Jay
 * @Date: 2023-04-28 09:42:18
 * @LastEditors: Jay
 * @LastEditTime: 2025-11-07 13:22:09
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//动态路由方法
import { setRoutes } from "./addRouteWay";

/**
 * 菜单参数介绍
 *    path  路由跳转地址
 *    name 路由跳转名字
 *    component 路由页面地址
 *    redirect 路由重定向
 *    hidden  当前路由 是否在菜单列表隐藏
 *    alwaysShow  折叠菜单是否展示
 *    meta {  自定义参数
 *        title: '页面名字',
 *        roles: ["all"],   //设置该路由进入的权限，支持多个权限叠加
 *        requireAuth: true,  //表示需要登录
 *        iconImg: require('../assets/menuApp/icon-menu1.png'),  //菜单 图标 icon (目前只支持饿了么UI图标) 或 img （图片地址）
 *    }
 *  */

//通用页面：不需要守卫，可直接访问
export const constantRoutes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/LoginView/LoginView.vue'),
    meta: {
      title: "登录",
    },
    hidden: true
  }, {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/LoginView/ForgetPassword.vue'),
    meta: {
      title: "忘记密码",
    },
    hidden: true
  }, {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: () => import('../views/Other/Agreement/privacyAgreement.vue'),
    meta: {
      title: "隐私协议",
    },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('../components/NotFound/NotFound.vue'),
    hidden: true
  }
]

//权限页面：登录并拥有访问权限的角色才能访问
export const asyncRoutes = [
  {
    path: '*',
    component: () => import('../components/NotFound/NotFound.vue'),
    hidden: true
  },
  {
    path: '/layout',
    name: 'layout',
    component: () => import('@/views/layout/menuApp.vue'),
    hidden: true,
    meta: {
      //表示需要登录
      requireAuth: true,
      // 设置该路由进入的权限，支持多个权限叠加
      roles: ["all"],
    },
    children: [
      // 新网银行电子协议详情
      {
        path: '/singNetDetails',
        name: 'singNetDetails',
        component: () => import('@/views/DownloadCenter/SingNet/SingNetDetails.vue'),
        hidden: true,
        meta: {
          title: '新网银行电子协议详情',
          // 设置该路由进入的权限，支持多个权限叠加
          roles: ["all"],
          //表示需要登录
          requireAuth: true
        }
      },
    ]
  }
]

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    //路由模式 
    // mode: 'history',
    mode: 'hash',
    //路由
    routes: constantRoutes
  })

const router = createRouter()

// 解决路由重复
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 获取原型对象上的replace函数
const originalReplace = VueRouter.prototype.replace;
//修改原型对象中的replace方法
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

// 前置-导航守卫
router.beforeEach(async (to, from, next) => {
  //刷新身份-添加路由
  try {
    await setRoutes()
    /* -----判断该路由是否需要登录----- */
    if (to.meta.requireAuth) {
      /* -----通过本地缓存进行判断,获取指定key本地存储的值进行判断----- */
      let token = sessionStorage.getItem('Authorization')
      if (token === null || token === '') {
        // console.log('去登录');
        router.replace('/')
      } else {
        next()
      }
    } else {
      next()
    }
  } catch (err) {
    console.error(err)
  }
})

//后置守卫
/* eslint-disable */
router.afterEach((to, from) => {
  //设置标题
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = ''
  }
})
/* eslint-disable no-new */

//重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

//初始化-添加路由
setRoutes()
